import React from 'react';
import { setEditId, StickerInterface } from "../../../../store/sticker_maker/stickersSlice";
import { formattedDate } from "../../../../helpers/DateHelpers";
import CardImage from "../../../../componets/CardImage";
import IconText from "../../../../componets/IconText";
import {
  CheckCircleOutlined,
  HeartOutlined,
  LikeOutlined,
  StopOutlined,
} from "@ant-design/icons";
import { Button, ButtonDestroy, ButtonEdit } from "../../../../componets/Buttons";
import { EntityId } from "@reduxjs/toolkit";
import { approveSticker, blockSticker, destroySticker } from "../../../../actions/sticker_maker/stickersActions";
import { message } from "antd";
import { useAppDispatch } from "../../../../store/hooks";
import { StatusTag } from "./_Tags";

const Card = ({ sticker }: { sticker: StickerInterface }) => {
  const dispatch            = useAppDispatch();
  const formattedCreatedAt  = formattedDate(sticker.created_at);
  const options             = [
    <ButtonEdit key={`edit-${sticker.id}`} onClick={() => onClickEdit(sticker.id)} />,
    <ButtonDestroy key={`destroy-${sticker.id}`} onClick={() => onClickDestroy(sticker.id, sticker.sticker_pack_id)} />
  ];

  function onClickEdit(id: EntityId) {
    dispatch(setEditId(id));
  }

  function onClickDestroy(id: EntityId, stickerPackId: EntityId) {
    handleDestroy(id, stickerPackId).catch(console.error);
  }

  async function handleDestroy (id: any, stickerPackId: any) {
    const resultAction = await dispatch(destroySticker({ id, stickerPackId }));

    if (destroySticker.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
    }

    if (destroySticker.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  function onClickApprove(id: number) {
    dispatch(approveSticker(id));
  }

  function onClickBlock(id: number) {
    dispatch(blockSticker(id));
  }

  if (sticker.status !== 2) {
    options.unshift(
      <Button key={`block-${sticker.id}`} title='Block' onClick={() => onClickBlock(sticker.id)} icon={StopOutlined} />
    );
  }

  if (sticker.status !== 1) {
    options.unshift(
      <Button key={`approve-${sticker.id}`} title='Approve' onClick={() => onClickApprove(sticker.id)} icon={CheckCircleOutlined} />
    );
  }

  return (
    <CardImage
      key={sticker.id}
      image={sticker.image_url}
      preview={true}
      stats={[
        <IconText icon={HeartOutlined} text={sticker.popular_count} tooltip='popular' />,
        <IconText icon={LikeOutlined} text={sticker.likes_count} tooltip='stickers' />
      ]}
      options={options}
      labels={[<StatusTag key={`status-tag-${sticker.id}`} status={sticker.status} />]}
    >

      <div className='v-small_text'>
        {formattedCreatedAt && <small>{formattedCreatedAt.date} <small>{formattedCreatedAt.time}</small></small> }
      </div>
    </CardImage>
  )
}

export default Card;
